import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import StarIcon from '@mui/icons-material/Star';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/ListItemText": ListItemText, "@mui/icons-material/Star": StarIcon } } });
export default ClientProvider;
